var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keywordCloud"},[_c('div',{ref:"wordCloud",staticClass:"word-cloud"})])
}
var staticRenderFns = []

export { render, staticRenderFns }